import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const CarouselTrack = styled.div`
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: stretch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;

export const CardWrapper = styled.div<{ $interactive?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  padding: 16px;
  margin: 20px 0 16px 0px;
  cursor: ${(props) => (props.$interactive ? "pointer" : "default")};
  outline: none;

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(17, 147, 64, 0.18);
  }
`;

export const CarouselCard = styled.div<{ $interactive?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 16px;
  border: 1px solid #e7e7f0;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(4, 2, 34, 0.06);
  padding: 0;
  margin: 0;
  flex: 0 0 min(346px, 78vw);
  min-height: 156px;
  max-width: 346px;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  cursor: ${(props) => (props.$interactive ? "pointer" : "default")};
  outline: none;

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(17, 147, 64, 0.18);
  }

  @media (min-width: 769px) {
    flex-basis: 300px;
    max-width: 320px;
  }
`;

export const CornerBadge = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  max-width: 78%;
  padding: 5px 10px 5px 8px;
  border-radius: 0 0 10px 0;
  background: #f2ebff;
  color: #451999;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardContent = styled.div<{ $insetForBadge?: boolean }>`
  flex: 1;
  width: ${(props) => (props.$insetForBadge === undefined ? "auto" : "100%")};
  box-sizing: border-box;
  padding: ${(props) =>
    props.$insetForBadge === undefined
      ? "0 16px 0 0"
      : props.$insetForBadge
        ? "46px 16px 16px"
        : "16px"};
`;

export const CardTitle = styled.div`
  color: #040222;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 8px;
`;

export const CarouselCardTitle = styled.div`
  color: #040222;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 21px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const CardDescription = styled.div`
  color: #5b5675;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CarouselCardAddress = styled.div`
  color: #5b5675;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 22px;
  }
`;

export const RatingDistanceWrapper = styled.div`
  color: #5b5675;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 4px;
`;

export const BadgesContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding-top: 12px;
`;

export const Badge = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #f5f0ff;
  color: var(--Purple-P500, #451999);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const EmptyState = styled.div`
  display: flex;
  min-height: 132px;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 16px;
  border: 1px dashed #d8c9fb;
  background: rgba(255, 255, 255, 0.72);
  padding: 20px;
`;

export const EmptyStateText = styled.div`
  color: #5b5675;
  font-family: "Euclid Circular B", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
`;
